import type { ReactNode } from 'react';

import { ChatLayout } from './parts/chat-layout';
import type { AssistantScope } from '@/modules/assistant';

/**
 * The platform AI chat screen.
 *
 * ChatGPT-inspired layout: a left sidebar for conversation history, a right
 * panel for the conversation itself. Streaming is simulated client-side on top
 * of the assistant API's single-POST answer.
 *
 * The route that renders this sets `hideAssistant: true` in route context, so
 * the drawer widget does not duplicate the full screen.
 */
export function AiChatPage(): ReactNode {
  return <ChatLayout scope={'platform' as AssistantScope} />;
}
